import { render } from "./CreatePatient.vue?vue&type=template&id=2a00b276&scoped=true&ts=true"
import script from "./CreatePatient.vue?vue&type=script&lang=ts"
export * from "./CreatePatient.vue?vue&type=script&lang=ts"

import "./CreatePatient.vue?vue&type=style&index=0&id=2a00b276&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a00b276"]])

export default __exports__